import React, { useEffect, useState } from "react";
import { FaGlobe, FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import toast from "react-hot-toast";
import FilterComponent from "../components/FilterComponent";
import ProductsSection from "../components/ProductsSection";
import big from "../assets/big-size.jpg";

const Index = () => {
  const [categories, setCategoryies] = useState([]);
  const [data, setData] = useState(null);
  const [filters, setFilters] = useState({
    search: "",
    category: "",
    applicable: "",
    model: "",
  });

  console.log("Data ------------> ", data);

  useEffect(() => {
    const fetchData = async () => {
      setData(null);

      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.set(key, value);
      });

      try {
        const response = await fetch(
          `https://api.hsagold.in/products_app/all_products_info?${params.toString()}`,
          { method: "GET" }
        );

        const result = await response.json();

        if (result.status) {
          setData(result.Vehicle || []);
        } else {
          if (result.status_code === 404) {
            throw new Error("No Data found");
          }
          throw new Error("Error fetching products");
        }
      } catch (error) {
        setData([]);
        toast.error(error.message);
        console.error("Error fetching products", error);
      }
    };

    fetchData();
  }, [filters]);

  useEffect(() => {
    const fetchCategories = async () => {
      setData(null);

      try {
        const response = await fetch(
          `https://api.hsagold.in/products_app/category_list`,
          { method: "GET" }
        );

        const result = await response.json();

        if (result.status) {
          setCategoryies(
            result.Category?.map((category) => category.category_name) || []
          );
        } else {
          throw new Error(result.message || "Error fetching category");
        }
      } catch (error) {
        setCategoryies([]);
        toast.error("Error fetching category");
        console.error("Error fetching category", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <div className="flex bg-[#00ab4f] overflow-hidden flex flex-col items-center">
        <img
          alt="poster"
          src={big}
          className="h-full  w-full object-top m-auto responsive-img"
        />
      </div>
      <div className="bg-gray-100 pt-4">
        <div className="flex flex-col gap-4 max-w-6xl m-auto">
          <FilterComponent
            setFilters={setFilters}
            filters={filters}
            categoryOptions={categories}
          />

          <div className="bg-white hide-scroll rounded-xl overflow-x-auto w-full flex flex-col">
            {categories &&
              (filters.category ? [filters.category] : categories).map(
                (category) => (
                  <section key={category}>
                    <h3 className="p-2 rounded-t-xl bg-[#00ab4f] uppercase font-bold text-center text-white w-full text-xl">
                      {category}
                    </h3>
                    <ProductsSection
                      data={data?.filter((item) => item.category === category)}
                    />
                  </section>
                )
              )}

            {data?.length > 0 && (
              <div className="flex gap-2 p-4 ml-auto">
                <a
                  href={`https://scan.hsagold.in/products/${
                    filters.category
                      .trim()
                      .replace(/[^a-zA-Z0-9]/g, "_")
                      .toLowerCase() || "all"
                  }/index.pdf`}
                  target="_blank"
                  rel="noreferrer"
                  className="px-4 py-2 rounded-xl text-center text-white outline-none cursor-pointer bg-green-700 hover:bg-green-800"
                >
                  View PDF
                </a>
                <a
                  href={`http://api.whatsapp.com/send?text=*${
                    filters.category || "All Spare Parts"
                  } PDF :*%0Ahttps://scan.hsagold.in/products/${
                    filters.category
                      .trim()
                      .replace(/[^a-zA-Z0-9]/g, "_")
                      .toLowerCase() || "all"
                  }/index.pdf`}
                  target="_blank"
                  rel="noreferrer"
                  className="px-4 py-2 rounded-xl text-center text-white outline-none cursor-pointer bg-green-700 hover:bg-green-800"
                >
                  Share PDF
                </a>
              </div>
            )}
          </div>
        </div>

        <div className="bg-green-600 w-full py-2 mt-8">
          <div className="max-w-6xl m-auto">
            <div className="flex gap-2 items-center my-3 px-2">
              <FaLocationDot className="bg-white min-w-8 h-8 rounded-full text-green-600 p-1" />{" "}
              <address className="text-white text-xl">
                Plot No. 2857, Master Colony, Gopalpur, Cuttack, Odisha 753011
              </address>
            </div>
            <div className="flex gap-2 items-center my-3 px-2">
              <FaGlobe className="bg-white w-8 h-8 rounded-full text-green-600 p-1" />{" "}
              <span className="text-white text-xl">parts@hsagold.in</span>
            </div>
            <div className="flex gap-2 items-center my-3 px-2">
              <FaPhoneAlt className="bg-white w-8 h-8 rounded-full text-green-600 p-1" />{" "}
              <span className="text-white text-xl">+91 9337760727</span>
            </div>
            <div className="flex gap-2 items-center my-3 px-2">
              <FaLocationDot className="bg-white w-8 h-8 rounded-full text-green-600 p-1" />{" "}
              <a
                rel="noreferrer"
                target="_blank"
                href="http://www.hsagold.in"
                className="text-white text-xl underline"
              >
                www.hsagold.in
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
